import * as React from 'react';
import { History } from 'history';
import { ParentPageHeader } from '../components/ParentPageHeader';
import './PaymentSuccess.scss';

interface Props {
  history: History;
}

export const PaymentSuccess = (props: Props) => {
  const { history } = props;

  const onBackClick = () => {
    history.push({
      pathname: '/home'
    });
  };

  return (
    <main className="parentPage parentPaymentSuccess">
      <ParentPageHeader title="Payment complete" chips={[{ label: 'Booking payment received', tone: 'green' }]} />
      <section className="parentCard parentPaymentSuccess__card">
        <div className="parentPaymentSuccess__mark" aria-hidden="true">✓</div>
        <h2>Payment successful</h2>
        <p>Your booking has been submitted. Your school will send a separate notification when it is confirmed.</p>
        <button type="button" className="parentButton parentButton--primary" onClick={onBackClick}>Back to Parent Hub</button>
      </section>
    </main>
  );
};
